module.exports = __webpack_public_path__ + "static/img/Mohul.0965dbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mohul.jpg
// module id = ZJ2D
// module chunks = 1